import React from "react";
import { Mail, MapPin, Building2, User } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { COMPANY } from "@/i18n/translations";

export default function Contact() {
  const { t } = useApp();
  const rows = [
    { icon: Mail, label: t.contact.emailLabel, value: COMPANY.email, href: `mailto:${COMPANY.email}` },
    { icon: MapPin, label: t.contact.addressLabel, value: COMPANY.address },
    { icon: Building2, label: t.contact.companyLabel, value: `${COMPANY.name} — ${COMPANY.form}` },
    { icon: User, label: t.contact.president, value: COMPANY.president },
  ];
  return (
    <div className="mx-auto max-w-4xl px-6 py-16 sm:px-8" data-testid="contact-page">
      <header className="mb-10">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-cea-accent">{t.nav.contact}</p>
        <h1 className="mt-3 text-4xl font-extrabold tracking-tighter text-cea-ink sm:text-5xl">{t.contact.title}</h1>
        <p className="mt-3 text-slate-500">{t.contact.sub}</p>
      </header>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {rows.map((r, i) => {
          const Icon = r.icon;
          return (
            <div key={i} className="flex items-start gap-4 rounded-2xl border border-slate-200 bg-white p-6" data-testid={`contact-row-${i}`}>
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-cea-navy text-white">
                <Icon className="h-5 w-5" />
              </div>
              <div>
                <p className="text-xs font-bold uppercase tracking-[0.15em] text-slate-400">{r.label}</p>
                {r.href ? (
                  <a href={r.href} className="mt-1 block font-semibold text-cea-ink hover:text-cea-accent">{r.value}</a>
                ) : (
                  <p className="mt-1 font-semibold text-cea-ink">{r.value}</p>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-6 rounded-2xl border border-slate-200 bg-cea-surface p-6 text-sm text-slate-500" data-testid="contact-company-details">
        <p>{COMPANY.rcs} · SIREN {COMPANY.siren} · EUID {COMPANY.euid}</p>
        <p className="mt-1">{COMPANY.greffe}</p>
      </div>
    </div>
  );
}
